import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <footer className="p-4 bg-primary md:p-8 lg:p-10">
        <div className="mx-auto max-w-screen-xl text-center">
          <a
            href="#"
            className="flex justify-center items-center text-2xl font-semibold text-gray-900"
          >
            <svg
              className="mr-2 h-8"
              viewBox="0 0 33 33"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <img
                src="https://static.vecteezy.com/system/resources/previews/004/699/782/non_2x/jr-letter-logo-isolated-on-white-background-vector.jpg"
                alt="Job Route Logo"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_11430_22515"
                  x1="20.8102"
                  y1="23.9532"
                  x2="23.9577"
                  y2="12.9901"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#1724C9" />
                  <stop offset={1} stopColor="#1C64F2" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_11430_22515"
                  x1="28.0593"
                  y1="10.5837"
                  x2="19.7797"
                  y2="2.33321"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#1C64F2" />
                  <stop offset={1} stopColor="#0092FF" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_11430_22515"
                  x1="16.9145"
                  y1="5.2045"
                  x2="4.42432"
                  y2="5.99375"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#0092FF" />
                  <stop offset={1} stopColor="#45B2FF" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_11430_22515"
                  x1="16.0698"
                  y1="28.846"
                  x2="27.2866"
                  y2="25.8192"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#1C64F2" />
                  <stop offset={1} stopColor="#0092FF" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_11430_22515"
                  x1="8.01881"
                  y1="15.8661"
                  x2="15.9825"
                  y2="24.1181"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#1724C9" />
                  <stop offset={1} stopColor="#1C64F2" />
                </linearGradient>
                <linearGradient
                  id="paint5_linear_11430_22515"
                  x1="26.2004"
                  y1="21.8189"
                  x2="31.7569"
                  y2="10.6178"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#0092FF" />
                  <stop offset={1} stopColor="#45B2FF" />
                </linearGradient>
                <linearGradient
                  id="paint6_linear_11430_22515"
                  x1="6.11387"
                  y1="9.31427"
                  x2="3.14054"
                  y2="20.4898"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#1C64F2" />
                  <stop offset={1} stopColor="#0092FF" />
                </linearGradient>
                <linearGradient
                  id="paint7_linear_11430_22515"
                  x1="21.2932"
                  y1="8.78271"
                  x2="10.4278"
                  y2="11.488"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#1724C9" />
                  <stop offset={1} stopColor="#1C64F2" />
                </linearGradient>
                <linearGradient
                  id="paint8_linear_11430_22515"
                  x1="7.15667"
                  y1="21.5399"
                  x2="14.0824"
                  y2="31.9579"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#0092FF" />
                  <stop offset={1} stopColor="#45B2FF" />
                </linearGradient>
              </defs>
            </svg>
            Job Route
            <br />
            <br />
          </a>
          <ul className="flex flex-wrap justify-center items-center mb-6 text-gray-900">
            <li>
              <Link to="/About">
                <span href="#" className="mr-4 hover:underline md:mr-6 ">
                  About
                </span>
              </Link>
            </li>
            <li>
              <a href="#" className="mr-4 hover:underline md:mr-6">
                Coming Soon
              </a>
            </li>
            <li>
              <a href="#" className="mr-4 hover:underline md:mr-6 ">
                Coming Soon
              </a>
            </li>
            <li>
              <a href="#" className="mr-4 hover:underline md:mr-6">
                Coming Soon
              </a>
            </li>
            <li>
              <a href="#" className="mr-4 hover:underline md:mr-6">
                Coming Soon
              </a>
            </li>
            <li>
              <a href="#" className="mr-4 hover:underline md:mr-6">
                Coming Soon
              </a>
            </li>
            <li>
              <a href="#" className="mr-4 hover:underline md:mr-6">
                Coming Soon
              </a>
            </li>
          </ul>
          <span className="text-sm text-gray-500 sm:text-center">
            © 2058-2059{" "}
            <a href="#" className="hover:underline">
              Job Route™
            </a>
            . All Rights Reserved.
          </span>
        </div>
      </footer>
    </>
  );
};

export default Footer;
